import React from 'react';
import { ChevronRight } from 'lucide-react';
import type { Badge } from '@/types/achievement';
import { recentBadges } from '@/data/achievements';
import { useAchievements } from '../../hooks/useAchievements';
import { achievementsMapper } from '../../utils/achievementsMapper';

interface RecentBadgesProps {
  setActiveTab: (tab: string) => void;
  onBadgeClick?: (badge: Badge) => void;
}

const RecentBadges: React.FC<RecentBadgesProps> = ({ setActiveTab, onBadgeClick }) => {
  
  const { badges } = useAchievements();
  // console.log('badges:', badges);
  const recentBadges = achievementsMapper.getRecentBadges(badges, 6);
  
  const handleBadgeClick = (badge: Badge) => {
    if (onBadgeClick) {
      onBadgeClick(badge);
    }
  };

  return (
    <section className="overview-tab badges-section">
      <div className="flex flex-row justify-between items-stretch pt-4">
        <div className="flex flex-row items-start">
          <div className="w-9 h-9 mt-2 bg-gradient-to-br from-yellow-500 to-amber-400 rounded-xl shadow-lg flex items-center justify-center">
            <img className="h-9 w-auto object-center" src="/pages/achievements/Digital-Badges.png" alt="Digital Badges"/>
          </div>
          <div className="flex flex-col items-start ms-3">
            <span className="text-xl text-white">Recent Badges</span>
            <span className="text-sm text-white/60">Your latest achievements</span>
          </div>
        </div>
        <div className="items-end">
          <button 
            className="bg-transparent text-white border-0 focus:border-0 hover:border-0 no-underline font-normal text-sm"
            onClick={() => setActiveTab('badges')}
          >
            View All <ChevronRight size={16} className="inline -mt-1 ml-1"/>
          </button>
        </div>
      </div>

      <div className="flex flex-row flex-wrap gap-4 justify-center md:justify-start py-8">
        {recentBadges.map((badge, index) => (                    
          <div 
            key={index} 
            className="w-44 bg-white/30 border border-white rounded-lg shadow-sm cursor-pointer hover:bg-white/40 transition-colors"
            onClick={() => handleBadgeClick(badge)}
          >
            <div className="flex flex-col text-center items-center py-3">
              <img 
                className="h-16 w-auto object-center" 
                src={badge.image || badge.image_url || '/pages/achievements/Digital-Badges.png'} 
                alt={badge.name} onError={(e) => e.currentTarget.src = '/pages/achievements/Digital-Badges.png'}
              />
              <span className="text-sm text-white pt-1">{badge.name}</span>
              {badge.earned_at &&<span className="text-xs text-white/60 pt-1.5">{achievementsMapper.formatDate(badge.earned_at)}</span>}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default RecentBadges;